import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface ListWhatsAppLocationSetupParams {
  status: string;
}

const ConversationsService = {

  sendingLimit: (type: string, locationId: string, limit: string) =>
    requests(SERVICE_NAME.CONVERSATIONS_API).put(
      `messages/${locationId}/${type}/usage?newLimit=${limit}`,
      {}
    ),
};
export default ConversationsService;
